import Grid from '@material-ui/core/Grid'
import React from 'react'

import { PolicyName, Provider } from 'src/api/gen/api'
import { normalizeTo } from 'src/commons/temporalHelpers'
import { DateRangePicker, IDateTimeRange } from 'src/components/DatePickers'
import ValidationResults from 'src/components/FormValidator/ValidationResults'
import { MultiSelectChips } from 'src/components/Select'

import { FieldTitle } from '../../commons'

import { formRules } from '.'

interface IFieldProps {
  disabled?: boolean
  id?: string
  title: string
  validation: ValidationResults<typeof formRules>
}

interface IPeriodProps extends IFieldProps {
  handleChange: (value: IDateTimeRange) => void
  maxDate?: Temporal.ZonedDateTime
  maxDateMessage?: string
  startDisabled?: boolean
  value: IDateTimeRange
}

export const PeriodField = (props: IPeriodProps) => {
  return (
    <Grid id={props.id} container={true}>
      <Grid item={true} xs={12}>
        <FieldTitle title={props.title} />
      </Grid>
      <Grid item={true} xs={12}>
        <DateRangePicker
          disabled={props.disabled}
          startDisabled={props.startDisabled}
          value={props.value}
          onChange={props.handleChange}
          withTime={false}
          error={{
            from: !props.validation.isFieldValid('periodFrom'),
            to: !props.validation.isFieldValid('periodTo'),
          }}
          helperText={
            <React.Fragment>
              <div> {props.validation.getFieldErrorMsg('periodFrom')} </div>
              <div> {props.validation.getFieldErrorMsg('periodTo')} </div>
            </React.Fragment>
          }
        />
      </Grid>
    </Grid>
  )
}

export function DayField(props: IPeriodProps) {
  return (
    <Grid container={true}>
      <Grid item={true} xs={12}>
        <FieldTitle title={props.title} />
      </Grid>
      <Grid item={true} xs={12}>
        <DateRangePicker
          disabled={props.disabled}
          forceEnd={normalizeTo}
          disableFuture={true}
          value={props.value}
          onChange={props.handleChange}
          withTime={true}
          maxDate={props.maxDate}
          maxDateMessage={props.maxDateMessage}
          error={{
            from: !props.validation.isFieldValid('periodFrom'),
            to: false,
          }}
          helperText={
            <React.Fragment>
              <div> {props.validation.getFieldErrorMsg('periodFrom')} </div>
            </React.Fragment>
          }
        />
      </Grid>
    </Grid>
  )
}

interface IPoliciesProps extends IFieldProps {
  allPolicies: PolicyName[]
  handleChange: (value: any) => void
  oneLineSelect?: boolean
  value: string[]
  withSelectAll?: boolean
}
export const PoliciesField = (props: IPoliciesProps) => {
  const selectData = props.allPolicies.map((policy) => {
    return { label: policy.name, id: policy.id }
  })

  return (
    <div id={props.id}>
      <FieldTitle title={props.title} />
      <MultiSelectChips
        disabled={props.disabled}
        data={selectData}
        oneLineSelect={props.oneLineSelect ?? true}
        onMultiChange={props.handleChange}
        value={props.value}
        error={!props.validation.isFieldValid('policies')}
        helperText={props.validation.getFieldErrorMsg('policies')}
        withSelectAll={props.withSelectAll ?? true}
      />
    </div>
  )
}

interface IProviderProps extends IFieldProps {
  // List of IDs
  handleChange: (value: any) => void
  oneLineSelect?: boolean
  providers?: Provider[] | undefined
  value?: string[] | undefined
  withSelectAll?: boolean
}

export const buildItemsFromProviders = (providers?: Provider[] | undefined) =>
  (providers || []).map((provider) => ({
    id: provider.id,
    label: provider.name,
  }))

export const ProviderField = (props: IProviderProps) => {
  const { title, value, handleChange, validation, disabled, providers } = props

  return (
    <div id={props.id} style={{ display: 'flex', flexDirection: 'column' }}>
      <FieldTitle title={title} />
      <MultiSelectChips
        disabled={disabled}
        data={buildItemsFromProviders(providers)}
        oneLineSelect={props.oneLineSelect ?? true}
        onMultiChange={handleChange}
        value={value || []}
        error={!validation.isFieldValid('providers')}
        helperText={validation.getFieldErrorMsg('providers')}
        withSelectAll={props.withSelectAll ?? true}
      />
    </div>
  )
}
